import { fromJS } from 'immutable';
import { SET_PROJECT, SET_PROJECT_UNDOABLE } from './project';
import { isMobile } from '../components/PicabooResponsive';
// import Config from 'Config';

export const TOGGLE_SETTING = 'TOGGLE_SETTING';
export const ADD_HORIZONTAL_GUIDE = 'ADD_HORIZONTAL_GUIDE';
export const ADD_VERTICAL_GUIDE = 'ADD_VERTICAL_GUIDE';
export const CLEAR_ALL_GUIDES = 'CLEAR_ALL_GUIDES';
export const EDIT_PROJECT = 'EDIT_PROJECT';

export const measurementUnitOptions = [
  { label: 'Inches', value: 'INCHES' },
  { label: 'Picas', value: 'PICAS' },
];

export const columnCountOptions = [
  { label: 'Eight', value: 8 },
  { label: 'Ten', value: 10 },
  { label: 'Twelve', value: 12 },
];

export const measurementUnits = {
  INCHES: 'INCHES',
  PICAS: 'PICAS',
};

const initialState = fromJS({
  projectPK: -1,
  showSafety: true,
  snapToCenter: true,
  snapToObjects: true,
  snapToGuides: false,
  snapToGrid: false,
  snapToMargins: false,
  snapToColumns: false,
  showRulers: true,
  showGrids: false,
  showNotes: false,
  showMargins: false,
  rulerUnit: measurementUnits.INCHES,
  gridUnit: measurementUnits.INCHES,
  showColumns: false,
  columnCount: 8,
  horizontalGuides: [],
  verticalGuides: [],
  thumbPlaceholders: false,
  gridScale: 5,
  warningsThisSpreadOnly: true,
});

const PROJECT_SETTINGS_ATTRIBUTES = [
  'horizontalGuides',
  'verticalGuides',

  'fontFamily',
  'fontSize',
  'fontColor',
];

/**
 * Reducers
 */
let firstLoad = true;

const reducer = (state = initialState, action) => {
  let storage = window.localStorage;
  let altered = false;

  let storageKey = 'editorSettings';

  switch (action.type) {
    case SET_PROJECT:
    case SET_PROJECT_UNDOABLE:
      if (storage) {
        if (firstLoad && storage.getItem(storageKey)) {
          state = fromJS(JSON.parse(storage.getItem(storageKey)));
          if (isMobile()) {
            state = state.set('showSafety', true);
            firstLoad = false;
          }
        }
        state = state.set('horizontalGuides', fromJS([]));
        state = state.set('verticalGuides', fromJS([]));
        if (state.get('projectPK') === -1 && action.project.project.projectPK) {
          const projectSettings = JSON.parse(
            storage.getItem(
              'editorSettings' + action.project.project.projectPK,
            ),
          );
          if (projectSettings) {
            PROJECT_SETTINGS_ATTRIBUTES.forEach((p) => {
              if (projectSettings[p]) {
                state = state.set(
                  p,
                  typeof projectSettings[p] === 'object'
                    ? fromJS(projectSettings[p])
                    : projectSettings[p],
                );
              }
            });
            //state = state.set('horizontalGuides', fromJS(projectSettings.horizontalGuides));
            //state = state.set('verticalGuides', fromJS(projectSettings.verticalGuides));
          }
        }
        state = state.set('projectPK', action.project.project.projectPK);
      }
      break;
    case TOGGLE_SETTING:
      altered = true;
      state = state.set(action.setting, action.value);
      break;
    case ADD_HORIZONTAL_GUIDE:
      altered = true;
      let hGuides = state.get('horizontalGuides').toJS();
      hGuides.push(action.value);
      state = state.set('horizontalGuides', fromJS(hGuides));
      break;
    case ADD_VERTICAL_GUIDE:
      altered = true;
      let vGuides = state.get('verticalGuides').toJS();
      vGuides.push(action.value);
      state = state.set('verticalGuides', fromJS(vGuides));
      break;
    case CLEAR_ALL_GUIDES:
      altered = true;
      state = state
        .set('verticalGuides', fromJS([]))
        .set('horizontalGuides', fromJS([]));
      break;
  }

  //store the state to the html5 localstore, because we can...
  if (altered && storage) {
    let stateForStorage = state.toJS();
    stateForStorage.projectPK = -1;
    stateForStorage.horizontalGuides = [];
    stateForStorage.verticalGuides = [];

    PROJECT_SETTINGS_ATTRIBUTES.forEach((p) => {
      delete stateForStorage[p];
    });

    storage.setItem(storageKey, JSON.stringify(stateForStorage));

    if (state.get('projectPK') !== -1) {
      let projectSettings = {}; //{horizontalGuides: state.get('horizontalGuides').toJS(), verticalGuides: state.get('verticalGuides').toJS()};

      PROJECT_SETTINGS_ATTRIBUTES.forEach((p) => {
        try {
          if (state.has(p) && state.get(p)) {
            let value = state.get(p);
            if (typeof value.toJS === 'function') {
              value = value.toJS();
            }

            projectSettings[p] = value;
          }
        } catch (e) {
          console.error('Error saving project settings', e);
        }
      });

      storage.setItem(
        'editorSettings' + state.get('projectPK'),
        JSON.stringify(projectSettings),
      );
    }
  }

  return state;
};

/**
 * actions
 */

export function toggleSetting(setting, value) {
  return {
    type: TOGGLE_SETTING,
    setting,
    value,
  };
}

export function addHorizontalGuide(value) {
  return {
    type: ADD_HORIZONTAL_GUIDE,
    value,
  };
}

export function addVerticalGuide(value) {
  return {
    type: ADD_VERTICAL_GUIDE,
    value,
  };
}

export function clearAllGuides(value) {
  return {
    type: CLEAR_ALL_GUIDES,
    value,
  };
}

/** ***********************************************************************
 *  Main Export
 *  *********************************************************************** */
export default {
  reducer: reducer,
};
